<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      :page.sync="page"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :header-cell-class-name="headerCellClassName"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @size-change="sizeChange"
      @current-change="currentChange"
      @row-del="rowDel"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        <!-- <el-button type="danger" size="small" icon="el-icon-delete" plain @click="handleDelete">删 除</el-button> -->
      </template>

      <template slot-scope="{ row }" slot="avatar">
        <el-avatar v-if="row.avatar" shape="square" :size="42" :src="row.avatar"></el-avatar>
        <span v-else>--</span>
      </template>

      <template slot-scope="{ row }" slot="menu">
        <el-button type="text" size="small" @click="handleEdit(row)">修改</el-button>
        <el-button type="text" size="small" @click="rowDel(row)">删除</el-button>
      </template>
    </avue-crud>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="720px" :before-close="closeDialog" class="doctor-dialog">
      <el-form ref="doctorForm" :model="doctorForm" :rules="rules" label-width="100px" size="small">
        <el-row :gutter="30">
          <el-col :span="12">
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="doctorForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="慢病：" prop="professionalField">
              <!-- <el-select v-model="doctorForm.disease" placeholder="请选择管理的慢病" filterable clearable multiple allow-create default-first-option>
                <el-option v-for="item in diseaseOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select> -->
              <el-select v-model="doctorForm.professionalField" placeholder="请选择管理的慢病" filterable clearable allow-create default-first-option>
                <el-option v-for="item in diseaseOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位：" prop="hospital">
              <el-input v-model="doctorForm.hospital" placeholder="请输入单位"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职称：" prop="title">
              <el-input v-model="doctorForm.title" placeholder="请输入职称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="职务：" prop="position">
              <el-input v-model="doctorForm.position" placeholder="请输入职务，以逗号分隔"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="擅长领域：" prop="specialty">
          <el-input v-model="doctorForm.specialty" placeholder="请输入擅长领域，以逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="学术任职：" prop="academicPosition">
          <el-input v-model="doctorForm.academicPosition" placeholder="请输入学术任职，以逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="研究成果：" prop="researchAchievement">
          <el-input v-model="doctorForm.researchAchievement" placeholder="请输入研究成果，以逗号分隔"></el-input>
        </el-form-item>

        <el-form-item label="头  像：" prop="avatar">
          <el-upload class="avatar-uploader" action="#" :show-file-list="false" :http-request="uploadAvatar" :before-upload="beforeAvatarUpload">
            <img v-if="doctorForm.avatar" :src="doctorForm.avatar" class="avatar-img" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">请上传尺寸为1:1.2，小于等于2MB的jpeg、png、jpg图片</div>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="submitLoading" @click="submitDoctor">确定</el-button>
      </template>
    </el-dialog>
  </basic-container>
</template>

<script>
import { request } from "@/util/http";
import { mapGetters } from "vuex";
import { getPage, saveIntroduction, removeIntroduction } from "@/api/health/doctorIntroduction";

const OSS = require("ali-oss");
const client = new OSS({
  region: "oss-cn-shanghai",
  endpoint: "oss-cn-shanghai.aliyuncs.com",
  accessKeyId: "LTAI4GGYDGZjaZQyshkjPBJH",
  accessKeySecret: "5O9VCIRDa6AqHtVj2NDiMUO9Uv2GDe",
  bucket: "health-planet",
});

// const getList = (current, size, params) => {
//   return request({
//     url: "此处放列表接口",
//     method: "get",
//     params: {
//       ...params,
//       current,
//       size,
//     },
//   });

//   return [];
// };

// const submit = (row) => {
//   return request({
//     url: "此处放添加接口",
//     method: "post",
//     data: row,
//   });
// };

const remove = (ids) => {
  return request({
    url: "此处放删除接口",
    method: "post",
    params: {
      ids,
    },
  });
};

export default {
  data() {
    return {
      form: {},
      data: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      params: {},
      selectionList: [],
      dialogVisible: false,
      dialogTitle: "新增医生",
      dialogType: "add",
      submitLoading: false,
      headerCellClassName: "headerClass",
      doctorForm: this.getDefaultForm(),
      diseaseOptions: [
        { label: "体重控制", value: "1" },
        { label: "高血压病", value: "2" },
        { label: "2型糖尿病", value: "3" },
        { label: "冠心病", value: "4" },
        { label: "缺血性脑卒中", value: "5" },
        { label: "肺结节", value: "6" },
      ],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        professionalField: [{ required: true, message: "请选择管理的慢病", trigger: "change" }],
        hospital: [{ required: true, message: "请输入单位", trigger: "blur" }],
        title: [{ required: true, message: "请输入职称", trigger: "blur" }],
        position: [{ required: true, message: "请输入职务", trigger: "blur" }],
        specialty: [{ required: true, message: "请输入擅长领域", trigger: "blur" }],
        academicPosition: [{ required: true, message: "请输入学术任职", trigger: "blur" }],
        researchAchievement: [{ required: true, message: "请输入研究成果", trigger: "blur" }],
        avatar: [{ required: true, message: "请上传头像", trigger: "change" }],
      },
      option: {
        tip: false,
        border: true,
        index: true,
        indexLabel: "序号",
        selection: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menuWidth: 120,
        searchMenuSpan: 4,
        column: [
          {
            label: "头像",
            prop: "avatar",
            slot: true,
            display: false,
            width: 80,
            align: "center",
          },
          {
            label: "姓名",
            prop: "name",
            search: true,
            searchSpan: 4,
            width: 100,
          },
          {
            label: "管理慢病",
            prop: "professionalField",
            search: true,
            searchSpan: 4,
            width: 120,
            type: "select",
            dicData: [
              { label: "体重控制", value: 1 },
              { label: "高血压病", value: 2 },
              { label: "2型糖尿病", value: 3 },
              { label: "冠心病", value: 4 },
              { label: "缺血性脑卒中", value: 5 },
              { label: "肺结节", value: 6 },
            ],
          },
          {
            label: "单位",
            prop: "hospital",
            minWidth: 160,
            overHidden: true,
          },
          {
            label: "职称",
            prop: "title",
            width: 110,
          },
          {
            label: "职务",
            prop: "position",
            width: 110,
          },
          {
            label: "擅长领域",
            prop: "specialty",
            minWidth: 180,
            overHidden: false,
          },
          {
            label: "学术任职",
            prop: "academicPosition",
            minWidth: 180,
            overHidden: false,
          },
          {
            label: "研究成果",
            prop: "researchAchievement",
            minWidth: 180,
            overHidden: false,
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 160,
            display: false,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: true,
        viewBtn: false,
        delBtn: true,
        editBtn: false,
      };
    },
    ids() {
      return this.selectionList.map((item) => item.id).join(",");
    },
  },
  methods: {
    getDefaultForm() {
      return {
        name: "",
        disease: [],
        hospital: "",
        title: "",
        position: "",
        specialty: "",
        academicPosition: "",
        researchAchievement: "",
        avatar: "",
      };
    },
    handleAdd() {
      this.dialogTitle = "新增医生";
      this.dialogType = "add";
      this.doctorForm = this.getDefaultForm();
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.doctorForm && this.$refs.doctorForm.clearValidate();
      });
    },
    handleEdit(row) {
      this.dialogTitle = "修改医生";
      this.dialogType = "edit";
      this.doctorForm = {
        ...this.getDefaultForm(),
        ...row,
        professionalField: row.professionalField === undefined || row.professionalField === null ? "" : String(row.professionalField),
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.doctorForm && this.$refs.doctorForm.clearValidate();
      });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.submitLoading = false;
      this.dialogTitle = "新增医生";
      this.dialogType = "add";
      this.doctorForm = this.getDefaultForm();
    },
    beforeAvatarUpload(file) {
      const isImage = ["image/jpeg", "image/png", "image/jpg"].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 <= 2;

      if (!isImage) {
        this.$message.error("上传头像图片只能是 JPG、JPEG 或 PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return false;
      }

      return new Promise((resolve, reject) => {
        const img = new Image();
        const url = URL.createObjectURL(file);
        img.onload = () => {
          URL.revokeObjectURL(url);
          const ratio = img.width / img.height;
          const targetRatio = 1 / 1.2;
          if (Math.abs(ratio - targetRatio) > 0.03) {
            this.$message.error("上传头像图片尺寸比例需为 1:1.2!");
            reject(new Error("图片比例不符合要求"));
            return;
          }
          resolve(true);
        };
        img.onerror = () => {
          URL.revokeObjectURL(url);
          this.$message.error("图片读取失败，请重新上传!");
          reject(new Error("图片读取失败"));
        };
        img.src = url;
      });
    },
    async uploadAvatar(options) {
      try {
        const file = options.file;
        const fileName = file.name.substr(0, file.name.lastIndexOf(".")) || "doctor-avatar";
        const fileType = file.name.substr(file.name.lastIndexOf(".") + 1);
        const ossFileName = `doctor/${new Date().getTime()}_${fileName}.${fileType}`;
        const res = await client.put(ossFileName, file);
        if (res.res.statusCode === 200) {
          this.doctorForm.avatar = res.url;
          this.$refs.doctorForm && this.$refs.doctorForm.validateField("avatar");
          options.onSuccess(res);
        } else {
          options.onError("上传失败");
        }
      } catch (e) {
        options.onError("上传失败");
        this.$message.error("头像上传失败");
      }
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => remove(this.ids))
        .then(() => {
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },
    searchReset() {
      this.params = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.params = params;
      this.page.currentPage = 1;
      console.log("searchChange", params);
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },

    onLoad(page, params = {}) {
      const param = {
        page: this.page,
        userDoctorIntroduction: this.params,
      };
      console.log("param", param);
      getPage(param).then((res) => {
        this.page.total = res.data.total || 0;
        this.data = res.data.records || [];
      });
    },

    submitDoctor() {
      console.log("submitDoctor", this.doctorForm);
      this.$refs.doctorForm.validate((valid) => {
        if (!valid) return;
        this.submitLoading = true;
        saveIntroduction(this.doctorForm)
          .then(() => {
            this.$message({
              type: "success",
              message: this.dialogType === "edit" ? "修改成功!" : "新增成功!",
            });
            this.closeDialog();
            this.onLoad(this.page, this.params);
          })
          .catch(() => {
            this.submitLoading = false;
          });
      });
    },

    rowDel(row) {
      console.log("rowDel", row);
      removeIntroduction(row.id)
        .then(() => {
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(() => {
          this.submitLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.doctor-dialog /deep/ .el-dialog__body {
  padding: 18px 28px 6px;
}

.doctor-dialog /deep/ .el-form-item__label {
  color: #333;
  font-weight: 600;
}

.doctor-dialog /deep/ .el-select {
  width: 100%;
}

.avatar-uploader /deep/ .el-upload {
  width: 98px;
  height: 98px;
  border: 1px solid #e5e5e5;
  background: #fff;
  cursor: pointer;
  overflow: hidden;
}

.avatar-uploader-icon {
  width: 98px;
  height: 98px;
  line-height: 98px;
  color: #e5e5e5;
  font-size: 30px;
  text-align: center;
}

.avatar-img {
  display: block;
  width: 98px;
  height: 98px;
  object-fit: cover;
}

.upload-tip {
  margin-top: 8px;
  color: #b5b5b5;
  font-size: 13px;
  line-height: 20px;
}

/* .doctor-dialog /deep/ .headerClass,
/deep/ .headerClass {
  background-color: #409eff !important;
  color: #fff !important;
} */
</style>
